import { render, staticRenderFns } from "./AttachmentInsurerAvailableCategoriesConfigs.vue?vue&type=template&id=3798d808&"
import script from "./AttachmentInsurerAvailableCategoriesConfigs.vue?vue&type=script&lang=js&"
export * from "./AttachmentInsurerAvailableCategoriesConfigs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports